import type { CountryCode, E164Number } from 'libphonenumber-js/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { isSupportedCountry } from 'react-phone-number-input';

export const getSupportedPhoneCountryCode = (countryCode?: string): CountryCode | undefined => {
  if (!countryCode) return undefined;

  const supportedCountryCode = countryCode as CountryCode;
  return isSupportedCountry(supportedCountryCode) ? supportedCountryCode : undefined;
};

export const normalizePhoneNumberValue = (phone: string | undefined, countryCode?: CountryCode): E164Number | undefined => {
  const normalizedPhone = phone?.trim() ?? '';

  if (normalizedPhone === '') {
    return undefined;
  }

  return parsePhoneNumberFromString(normalizedPhone, countryCode)?.number;
};

export const phoneNumberIsPossible = (phone: string, countryCode?: CountryCode): boolean => {
  return parsePhoneNumberFromString(phone.trim(), countryCode)?.isPossible() ?? false;
};
